import RouterLink from '@components/RouterLink';
import { Divider } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import AuthWrapper from './AuthWrapper';
import AuthLogin from './auth-forms/LoginForm';

// ================================|| LOGIN ||================================ //
export function Component() {
    const { t, i18n } = useTranslation();

    const link =
        i18n.resolvedLanguage === 'de'
            ? 'https://eye-able.com/testlizenz-assistenzsoftware/'
            : 'https://eye-able.com/en/test-license-assistance-software/';

    return (
        <AuthWrapper title={t('loginTitle')}>
            <Grid alignItems='center' container spacing={2}>
                <Grid xs={12}>
                    <AuthLogin />

                    <Divider sx={{ mt: 3.5, mb: 3, mx: 2 }} />

                    <RouterLink sx={{ textDecoration: 'underline' }} to={link}>
                        {t('noAccountTryEyeAble')}
                    </RouterLink>
                </Grid>
            </Grid>
        </AuthWrapper>
    );
}
